<template>
  <div class="notification__simple">
    <div class="notification__header">
      <p class="notification__title">
        {{ lastItem.title }}
      </p>
      <span
        class="notification__close"
        @click="hideNotification">x</span>
    </div>
    <div class="notification__body">
      <div class="notification__simple-message">
        {{ lastItem.message }}
      </div>
    </div>
    <div class="notification__footer">
      <p
        class="notification__button"
        @click="hideNotification">
        Ok
      </p>
    </div>
  </div>
</template>

<script>
import {
  // eslint-disable-next-line no-unused-vars
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';

export default {
  name: 'NotificationsItemSimple',

  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  computed: {
    lastItem() {
      return this.notification.items[this.notification.items.length - 1];
    },
  },

  methods: {
    hideNotification() {
      this.$emit('hide', this.notification.id);
    },
  },
};
</script>

<style lang="scss" scoped>
  .notification__body {
    position: relative;
  }

  .notification__header {
    position: relative;
  }

  .notification__close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 8px;
    transform: translate(50%, -50%);
    cursor: pointer;
  }

  .notification__simple-message {
    min-height: 31px;
    line-height: 1.25;
  }

  .notification__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .notification__date {
    font-size: 1.1rem;
  }

  .notification__button {
    padding: .75rem 1.25rem;
    background: $color--basic-blue;
    color: #fff;
    font-size: $text-15px;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 5px;

    &:hover {
      background: $color--additional-blue;
    }
  }
</style>
